import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Close as CloseIcon } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Portal } from "@air/primitive-portal";
import { memo } from "react";
export const CLOSE_BOARD_CUSTOM_FIELD_PANEL_BUTTON = "CLOSE_BOARD_CUSTOM_FIELD_PANEL_BUTTON";
export const CustomFieldsPanel = /*#__PURE__*/ memo((param)=>{
    let { children, breadcrumbs, footer, onClose, title } = param;
    return /*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "fixed inset-0 bg-black/60",
                    "data-testid": "CUSTOM_FIELDS_PANEL_OVERLAY",
                    onClick: onClose
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "fixed inset-y-0 right-0 flex w-[396px] flex-col overflow-hidden bg-surface-1",
                    "data-disableselect": "true",
                    "data-testid": "CUSTOM_FIELDS_PANEL",
                    children: [
                        /*#__PURE__*/ _jsxs("header", {
                            className: "flex shrink-0 flex-col gap-2 border-b border-b-grey-5 px-6 py-4",
                            children: [
                                !!title && /*#__PURE__*/ _jsx("h1", {
                                    className: "order-2 text-20 font-semibold text-grey-12",
                                    children: title
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "order-1 flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            children: breadcrumbs
                                        }),
                                        /*#__PURE__*/ _jsx(IconButton, {
                                            appearance: "ghost",
                                            color: "grey",
                                            className: "shrink-0",
                                            "data-testid": CLOSE_BOARD_CUSTOM_FIELD_PANEL_BUTTON,
                                            icon: CloseIcon,
                                            label: "Close",
                                            onClick: onClose
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "h-screen grow overflow-auto p-6",
                            children: children
                        }),
                        !!footer && /*#__PURE__*/ _jsx("footer", {
                            className: "shrink-0 border-t border-t-grey-5 px-6 py-4",
                            children: footer
                        })
                    ]
                })
            ]
        })
    });
});
CustomFieldsPanel.displayName = "CustomFieldsPanel";
